import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import { utilCookies } from '@/util/cookies';
// 谷歌地图key
var key = 'AIzaSyArw4avyMPteftN-tVZHOO8VXiPiYImbzQ';
// 注册谷歌地图
Vue.use(VueGoogleMaps, {
  load: {
    key: key,
    libraries: 'places',
    region: 'VI',
    // 这个地区自己定
    language: utilCookies.getLanguage() || 'th' // 这个语言自己定
  },

  installComponents: true
});
// 谷歌地图api调用
import { gmapApi } from 'vue2-google-maps';
import store from 'storejs';
var lang = store.get('language');
var bases = {
  id: {
    lat: -6.2099463789942195,
    lng: 106.84221916284554,
    name: 'Jakarta'
  },
  other: {
    lat: 13.749978051743666,
    lng: 100.4913183032852,
    name: 'พระบรมมหาราชวัง'
  }
};
export default {
  props: {
    area: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {},
  data: function data() {
    return {
      googleOptions: {
        scaleControl: false,
        zoom: 14,
        // 是否展示地图默认组件
        mapTypeControl: false
      },
      visible: false,
      options: [],
      areaList: [],
      range: '',
      marker: '',
      // 印尼语默认地址 其他语言默认泰国
      centers: bases[lang] || bases.other,
      currentMap: {},
      position: {},
      positionList: []
    };
  },
  watch: {
    visible: function visible(v) {
      var _this = this;
      if (v) {
        if (this.area && this.area.length > 0) {
          // this.positionList
          this.areaList = this.area.map(function (item) {
            return {
              lng: item.area_lng || item.lng,
              lat: item.area_lat || item.lat,
              name: item.area_name || item.name,
              range: item.range || ''
            };
          });
        }
        this.$nextTick(function () {
          if (!_this.map) _this.getMapExample();
          _this.map && _this.areaList[0] && _this.changePosition(_this.areaList[0]);
        });
      }
    }
  },
  computed: {
    google: gmapApi
  },
  methods: {
    // 打卡范围大于0限制
    handleEnterNumber: function handleEnterNumber(e) {
      e = Number(e);
      if (e < 0) this.range = 0;
    },
    // 创建搜索框 监听输入
    createSearch: function createSearch() {
      var _this2 = this;
      // Create the search box and link it to the UI element.
      var input = document.createElement('input');
      input.className = 'el-input__inner';
      input.setAttribute('style', 'width: 316px; transform: translate(10px, 10px); height: 36px; z-index: 1000000');
      this.searchBox = new this.google.maps.places.SearchBox(input);
      this.map.controls[this.google.maps.ControlPosition.TOP_LEFT].push(input);
      // Bias the SearchBox results towards current map's viewport.
      this.map.addListener('bounds_changed', function () {
        _this2.searchBox.setBounds(_this2.map.getBounds());
      });
      this.searchBox.addListener('places_changed', function () {
        var places = _this2.searchBox.getPlaces();
        // console.log(places)
        _this2.positionList = places;
        var location = places[0].geometry.location;
        if (places.length == 0) {
          return;
        }
        _this2.currentMap = {
          lat: location.lat(),
          lng: location.lng(),
          name: places[0].formatted_address,
          title: places[0].formatted_address
        };
        _this2.changePosition(_this2.currentMap);
      });
    },
    // 获取实例
    getMapExample: function getMapExample() {
      var _this3 = this;
      this.$refs.mapRef.$mapPromise.then(function (map) {
        // 谷歌地图实例话对象
        _this3.map = map;
        _this3.createSearch();
        _this3.areaList[0] && _this3.changePosition(_this3.areaList[0]);
      });
    },
    // 删除列表项
    handleClose: function handleClose(num) {
      this.areaList.splice(num, 1);
    },
    // 定位
    changePosition: function changePosition(area) {
      this.centers = {
        lat: parseFloat(area.lat),
        lng: parseFloat(area.lng),
        title: area.name,
        name: area.name
      };
      // 更换位置
      this.map.panTo(this.centers || this.currentMap);
      this.Marker && this.Marker.setMap(null);
      // 添加标记
      this.Marker = new this.google.maps.Marker({
        position: this.centers,
        // draggable: true,  // 标记拖拽
        map: this.map
      });
      // 标记可拖拽
      // this.google.maps.event.addListener(this.Marker, 'dragend', function (MouseEvent) {
      //   alert(MouseEvent.latLng)
      // })
    },
    handlerAddList: function handlerAddList() {
      if (Object.keys(this.currentMap).length && this.range) {
        this.currentMap.range = this.range;
        this.areaList.push(this.currentMap);
        // this.currentMap = {}
        this.range = '';
        this.position = {};
      } else {
        this.$notify.info({
          title: this.$t('229'),
          message: this.$t('858')
        });
      }
    },
    changeCurrent: function changeCurrent(params) {
      var location = params.geometry.location;
      this.currentMap = {
        lat: location.lat(),
        lng: location.lng(),
        name: params.formatted_address,
        title: params.formatted_address
        // area_lat: location.lat(),
        // area_lng: location.lng(),
        // area_name: params.formatted_address
      };

      this.changePosition(this.currentMap);
    },
    confirm: function confirm() {
      this.visible = false;
      this.$emit('changeMap', this.areaList);
    }
  }
};